import React from 'react';
import type { PainelRegiao } from '../../types/pedidos';

interface AjusteRegiaoProps {
  pedido: PainelRegiao | null;
  onClose: () => void;
  onSaveSuccess: () => void;
  isFullscreen: boolean;
}

const AjusteRegiao: React.FC<AjusteRegiaoProps> = ({ 
  pedido, 
  onClose, 
  onSaveSuccess, 
  isFullscreen 
}) => {
  if (!pedido) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
        <h3 className="text-lg font-semibold mb-4">Ajustar Região</h3>
        <p className="mb-4">
          Pedido: {pedido.codigo} - {pedido.cliente}
        </p>
        <p className="mb-4 text-sm text-zinc-600">
          Fullscreen: {isFullscreen ? 'Ativo' : 'Inativo'}
        </p>
        
        <div className="flex gap-2">
          <button
            onClick={onSaveSuccess}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
          >
            Salvar
          </button>
          <button
            onClick={onClose}
            className="px-4 py-2 bg-zinc-300 text-zinc-700 rounded hover:bg-zinc-400"
          >
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
};

export default AjusteRegiao;